import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_NEW_RECORD } from '../actions';
import EnumRecordTypes from '../../enums/enumRecordTypes';
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
  createNewRecordSuccess,
  createNewRecordError
} from './actions';

import EnumNewsItemTypes from "../../enums/enumNewsItemTypes";

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createNewRecordAsync = async (newRecord, payload) => {
  console.log(payload);
  
  switch (newRecord.about_RecordType) {
    case EnumRecordTypes.Post:
      try {
        const postCreateRequest = {};
        const json_meta_data = {};
        json_meta_data.NewsSummary = newRecord.body;
        json_meta_data.NewsData = {};
        if (newRecord.renderType == EnumNewsItemTypes.Chart) {
          json_meta_data.NewsData.NewsItemType = EnumNewsItemTypes.Chart;
          json_meta_data.NewsData.ChartType = 2;
          json_meta_data.NewsData.NewsItemSource = 10;
          json_meta_data.NewsData.NewsItemSourceType = 20;
          json_meta_data.NewsData.FusionChart = newRecord.chartdata;
        }
        else if (newRecord.renderType == EnumNewsItemTypes.Image) {
          json_meta_data.NewsData.NewsItemType = EnumNewsItemTypes.Image;
          json_meta_data.NewsData.ItemUrl = newRecord.imageData;
          json_meta_data.NewsData.NewsItemSource = 10;
          json_meta_data.NewsData.NewsItemSourceType = 20;
        }
        else if (newRecord.renderType == EnumNewsItemTypes.Video) {
          json_meta_data.NewsData.NewsItemType = EnumNewsItemTypes.Video;
          json_meta_data.NewsData.ItemUrl = newRecord.videoData;
          json_meta_data.NewsData.NewsItemSource = 10;
          json_meta_data.NewsData.NewsItemSourceType = 20;
        }

        postCreateRequest.newsSummary = newRecord.body;
        postCreateRequest.newsItemType = json_meta_data.NewsData.NewsItemType;
        postCreateRequest.chartType = json_meta_data.NewsData.ChartType;
        postCreateRequest.newsItemSource = json_meta_data.NewsData.NewsItemSource;
        postCreateRequest.newsItemSourceType = json_meta_data.NewsData.NewsItemSourceType;
        postCreateRequest.itemUrl = json_meta_data.NewsData.ItemUrl;
        postCreateRequest.itemData = json_meta_data.NewsData.ItemData;
        postCreateRequest.fusionChart = json_meta_data.NewsData.FusionChart;

        postCreateRequest.newsItemId = newRecord.newsItemId;
        postCreateRequest.newsItemGuid = newRecord.newsItemGuid;
        postCreateRequest.jsonMetaData = json_meta_data;
        postCreateRequest.createdBy = newRecord.contactId;
        postCreateRequest.forRecordId = newRecord.contactId;
        postCreateRequest.for_RecordType = newRecord.recordType;
        postCreateRequest.aboutRecordId = newRecord.aboutRecordId;
        postCreateRequest.about_RecordType = newRecord.about_RecordType;
        postCreateRequest.recordState = newRecord.recordState;
        postCreateRequest.createdDate = newRecord.createdDate;

        postCreateRequest.lastUpdatedDate = new Date();
        if (!newRecord.createdDate) {
          postCreateRequest.createdDate = new Date();
        }
        postCreateRequest.lastUpdatedBy = newRecord.lastUpdatedBy;
        if (!postCreateRequest.lastUpdatedBy) {
          postCreateRequest.lastUpdatedBy = newRecord.contactId;
        }
        postCreateRequest.trashed = newRecord.trashed;

        let responseObject = {};

        if (newRecord.renderType == EnumNewsItemTypes.Article){
          const postUpdateRequest = {};
          const article_json_meta_data = {};

         article_json_meta_data.NewsItemType = EnumNewsItemTypes.Article;
         article_json_meta_data.ItemData = newRecord.articleData;
         article_json_meta_data.NewsItemSource = 10;
        article_json_meta_data.NewsItemSourceType = 20;
         article_json_meta_data.ImageBinaryFile = newRecord.articleImageData;
         article_json_meta_data.ImageFileName = newRecord.imageFileName;
         article_json_meta_data.ImageExtension = newRecord.imageExtension;
        article_json_meta_data.ItemUrl = newRecord.itemUrl;

         postUpdateRequest.title = newRecord.body;
          postUpdateRequest.jsonMetaData = article_json_meta_data;
         postUpdateRequest.createdBy = newRecord.contactId;
         postUpdateRequest.recordType = "Article";

          try{
              responseObject = await centralApiAxios.post("posts", postUpdateRequest, getActivityHeadersUpdated(payload));
          }
          catch(error){
            console.log(error.response.data);
          }
          
        }
        else{
          responseObject = await centralApiAxios.post("news_items", postCreateRequest, getActivityHeadersUpdated(payload));
        }
        
        return {
          newsItem: responseObject.data,
          newsItemId: responseObject.data.newsItemId,
          trashed: postCreateRequest.trashed,
          isNewsItemCreate: !(postCreateRequest.newsItemId > 0),
          message: ""
        };
      }
      catch (err) {
        return {
          message: CREATE_NEW_RECORD_ERROR,
        };
      }
    default:
      try {
        const contactCreateRequest = { ...newRecord };
        contactCreateRequest.lcid = 1033;
        if (contactCreateRequest.displayName == null && contactCreateRequest.recordType == 3010) {
          contactCreateRequest.displayName = `${contactCreateRequest.firstName} ${contactCreateRequest.lastName}`;
        }

        if (contactCreateRequest.contactId > 0) {
          const responseObject = await centralApiAxios.put(`contacts?id=${contactCreateRequest.contactId}`, contactCreateRequest, getActivityHeadersUpdated(payload));
          return {
            contactId: responseObject.data.contactId,
            trashed: contactCreateRequest.trashed,
            message: ""
          };
        }
        const responseObject = await centralApiAxios.post("contacts", contactCreateRequest, getActivityHeadersUpdated(payload));
        return {
          contactId: responseObject.data.contactId,
          trashed: contactCreateRequest.trashed,
          message: ""
        };
      } catch (err) {
        return {
          message: CREATE_NEW_RECORD_ERROR,
        };
      }
  }
};

function* createNewRecord({ payload }) {
  try {
    const resultReturned = yield call(createNewRecordAsync, payload.newRecord, payload);
    if (!resultReturned.message) {
      yield put(createNewRecordSuccess(resultReturned));
      window.location.reload();
    } else {
      yield put(createNewRecordError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createNewRecordError(CREATE_NEW_RECORD_ERROR));
  }
}

export function* watchCreateNewRecord() {
  yield takeEvery(CREATE_NEW_RECORD, createNewRecord);
}

export default function* rootSaga() {
  yield all([
    fork(watchCreateNewRecord)
  ]);
}
